import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-page-title',
  templateUrl: './pagetitle.component.html',
})
export class PagetitleComponent implements OnInit {
  @Input() breadcrumbItems: Array<{}>;
  @Input() title: string;

  constructor() { }

  ngOnInit() {
    this.breadcrumbItems.unshift({active: false, path: '', label: 'LABELS.BUYER_PORTAL'});
  }

}
